import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerBasicInfoRoutingModule } from './customer-basic-info-routing.module';
import { CustomerBasicInfoComponent } from './customer-basic-info.component';
import { MatButtonModule } from '@angular/material/button';
import { ProfilePhotoModule } from '../../portal/profile/profile-photo/profile-photo.module';
import { CustomerUserInfoFormModule } from './customer-user-info-form/customer-user-info-form.module';
import { CustomerIdUploadModule } from './customer-id-upload/customer-id-upload.module';
import { CustomerPhoneNumberEditModule } from '../customer-phone-number-edit/customer-phone-number-edit.module';

@NgModule({
  declarations: [CustomerBasicInfoComponent],
  imports: [
    CommonModule,
    CustomerBasicInfoRoutingModule,
    MatButtonModule,
    ProfilePhotoModule,
    CustomerUserInfoFormModule,
    CustomerIdUploadModule,
    CustomerPhoneNumberEditModule,
  ],
})
export class CustomerBasicInfoModule {}
